import React from 'react';
import styled, { css } from 'styled-components';
import { useDispatch } from 'react-redux';

import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Applications from '@zg-rentals/multibrand-ui/lib/icons/Applications';
import { Button, Flex, mediaMixin } from '@zillow/constellation';

import { URLS } from '../../constants/urls';
import { hideOnboarding } from '../../actions/initListingActionCreators';

const DESCRIPTION =
  'Finding a great tenant is easier with applications and screening tools all in one place. Use our online application form with background check and credit screening to find a renter quickly, for free!';
const TITLE = 'Simplify your rental process';
const BUTTON_TEXT = 'Get started';

const Description = styled(Text)``;
const SubmitButton = styled(Button)``;
const TermsOfUse = styled(Text)``;
const Icon = styled(Applications)`
  width: 80px;
`;

const Wrapper = styled(Flex)`
  text-align: center;

  ${mediaMixin(
    'md',
    css`
      ${Description} {
        max-width: 480px;
      }
      ${SubmitButton}, ${TermsOfUse} {
        max-width: 360px;
      }
    `,
  )};

  ${mediaMixin(
    'lg',
    css`
      ${Description} {
        max-width: 520px;
      }
    `,
  )};

  ${mediaMixin(
    'xl',
    css`
      ${Description} {
        max-width: 630px;
      }
      ${SubmitButton} {
        max-width: 430px;
      }
    `,
  )};
`;

export default function OnBoarding() {
  const dispatch = useDispatch();
  return (
    <Wrapper display="flex" flexDirection="column" alignItems="center" marginTop="xl" marginBottom="xl">
      <Icon size={null /* null lets us set the wrapper's width, instead of MUI */} color="#0074e4" />
      <Text type="h2">{TITLE}</Text>
      <Description type="body">
        {`${DESCRIPTION} `}
        <Link to={URLS.MARKETING_LANDING_PAGE} type="secondary" target="_blank">
          Learn more
        </Link>
      </Description>
      <SubmitButton
        buttonType="primary"
        marginTop="sm"
        marginBottom="sm"
        id="onboarding-start-button"
        onClick={() => {
          hideOnboarding(dispatch);
        }}
        fluid
      >
        {BUTTON_TEXT}
      </SubmitButton>
      <TermsOfUse type="body-tiny">
        By clicking Get started, I accept{' '}
        <Link to={URLS.TERMS_OF_USE} type="secondary" target="_blank">
          Zillow's Terms of Use
        </Link>{' '}
        and{' '}
        <Link to={URLS.RENTAL_USER_TERMS} type="secondary" target="_blank">
          Zillow Rental's Terms of Use
        </Link>
        .
      </TermsOfUse>
    </Wrapper>
  );
}
